"use client";

import { c as _c } from "react/compiler-runtime";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";
interface ThemeToggleProps {
  className?: string;
  size?: "default" | "compact";
}
export function ThemeToggle(t0) {
  const $ = _c(8);
  const {
    className,
    size: t1
  } = t0;
  const size = t1 === undefined ? "default" : t1;
  const {
    theme,
    setTheme,
    systemTheme
  } = useTheme();
  const [mounted, setMounted] = useState(false);
  const currentTheme = theme === "system" ? systemTheme : theme;
  const isDark = currentTheme === "dark";
  const sizeClasses = size === "compact" ? {
    root: "h-7 w-14",
    knob: "size-5",
    icon: "size-3.5",
    translate: "translate-x-7",
    negativeTranslate: "-translate-x-7"
  } : {
    root: "h-8 w-16",
    knob: "size-6",
    icon: "size-4",
    translate: "translate-x-8",
    negativeTranslate: "-translate-x-8"
  };
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setMounted(true);
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  if (!mounted) {
    return <div aria-hidden="true" className={cn("flex p-1 rounded-full cursor-pointer transition-all duration-300", sizeClasses.root, "bg-white border border-zinc-200", className)}><div className="flex justify-between items-center w-full"><div className={cn("flex justify-center items-center rounded-full transition-transform duration-300 transform bg-gray-200", sizeClasses.knob, sizeClasses.translate)}><Sun className={cn(sizeClasses.icon, "text-gray-700")} strokeWidth={1.5} /></div><div className={cn("flex justify-center items-center rounded-full transition-transform duration-300 transform", sizeClasses.knob, sizeClasses.negativeTranslate)}><Moon className={cn(sizeClasses.icon, "text-black")} strokeWidth={1.5} /></div></div></div>;
  }
  const t4 = cn("flex p-1 rounded-full cursor-pointer transition-all duration-300", sizeClasses.root, isDark ? "bg-zinc-950 border border-zinc-800" : "bg-white border border-zinc-200", className);
  let t5;
  if ($[2] !== isDark || $[3] !== setTheme) {
    t5 = () => setTheme(isDark ? "light" : "dark");
    $[2] = isDark;
    $[3] = setTheme;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = cn("flex justify-center items-center rounded-full transition-transform duration-300", sizeClasses.knob, isDark ? "bg-transparent" : `transform ${sizeClasses.negativeTranslate}`);
  const t7 = isDark ? <Sun className={cn(sizeClasses.icon, "text-gray-500")} strokeWidth={1.5} /> : <Moon className={cn(sizeClasses.icon, "text-black")} strokeWidth={1.5} />;
  let t8;
  if ($[5] !== t6 || $[6] !== t7) {
    t8 = <div className={t6}>{t7}</div>;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  return <button aria-label={`Switch to ${isDark ? "light" : "dark"} mode`} className={t4} onClick={t5} type="button"><div className="flex justify-between items-center w-full"><div className={cn("flex justify-center items-center rounded-full transition-transform duration-300", sizeClasses.knob, isDark ? "transform translate-x-0 bg-zinc-800" : `transform ${sizeClasses.translate} bg-gray-200`)}>{isDark ? <Moon className={cn(sizeClasses.icon, "text-white")} strokeWidth={1.5} /> : <Sun className={cn(sizeClasses.icon, "text-gray-700")} strokeWidth={1.5} />}</div>{t8}</div></button>;
}